import { gql } from "@apollo/client";

import { PERFORMANCE_GRAPH_FRAGMENT } from "@graphql/fragments";

export const PORTFOLIO_PERFORMANCE_GRAPH = gql`
  ${PERFORMANCE_GRAPH_FRAGMENT}
  query portfolioPerformanceGraph($beneficiaryId: String, $goalId: String, $nodeCount: Int) {
    oneDay: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: ONE_DAY
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    oneWeek: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: ONE_WEEK
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    oneMonth: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: ONE_MONTH
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    sixMonth: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: SIX_MONTH
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    oneYear: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: ONE_YEAR
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
    fiveYear: portfolioPerformanceGraph(
      input: {
        beneficiaryId: $beneficiaryId
        goalId: $goalId
        timeFrame: FIVE_YEAR
        nodeCount: $nodeCount
      }
    ) {
      ...PerformanceGraphFragment
    }
  }
`;
